<template>
      <nav>
	    <slot></slot>
      </nav>
   
</template>
<script>
	export default {
      data(){
      	return{

      	};
      }
  }
</script>

<style lang="scss">

body {
    position: relative;
    background : #F8F8F8;
    font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont,Helvetica Neue,Arial;
    box-sizing: border-box;
    color: #353C45;
    max-width: 100vw;
    margin: 0;
}

header {
    border-top: 3px solid #8cc42d;
    position: relative;
    overflow-x: hidden;
    width: 100vw;

    &:before {
        content: '';
        position: absolute;
        z-index: -1;
        top: -927px;
        background: #fff;
        width: 5452px;
        height: 1050px;
        left: calc(((5452px - 100vw) / 2) * -1);
         -webkit-border-radius: 150% /95%;
        -moz-border-radius:    150% / 95%; 
        border-radius:         150% / 95%;
        -webkit-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
        -moz-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
        box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
        z-index: 1000;
    }

    &:after {
      content: '';
      position: absolute;
      z-index: 1001;
      left: 0;
      height: 3px;
      background-color: #8cc42d; 
      width: 100vw;
      top: -3px;
    }
}

nav {
    position:relative;
    z-index: 1003;
    max-width: 1200px;


    @media ($desktop_only) {
        width: calc(100vw - 80px);
    }

    width: 100%;
    margin: 0 auto;
    overflow: clip;
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin-top: 31px;
    margin-bottom: 72px;

    #logo_monito a{
        display: inline-block;
        text-indent: -1000px;
        font-size: 1px;
        background-image:url('../assets/monito_logo.svg');
        background-repeat: no-repeat;
        width: 180px;
        margin-left: 26px;
        height: 48px;
        background-size: contain;
        background-position: center;
        z-index: 100;
        vertical-align: middle;
    }
    ul {
        display: inline-block;
        list-style: none;
        li {
            display: inline-block;
            padding: 0 36px;

            a {
                text-decoration: none;
                color: #cdcdcd;
                font-size: 13px;
                color: #6f747a;
                font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont,Helvetica Neue,Arial;
                font-weight: 700;
                letter-spacing: 0.045em;
                text-transform: uppercase;

            }

            &.langage {
                a {
                    color: #000;
                }		
                
                &:after {
                    content: '';
                    background-image: url('../assets/arrow_down.svg');
                    background-position: top;
                    margin-left: 3px;
                    background-repeat: no-repeat;
                    background-size: contain;
                    width: 10px;
                    height: 8px;
                    display: inline-block;
                }
            }

            &:hover {
                a {
                    transition: all 0.3s ease;
                    color: #000;
                }
            }
        }
    }
}


 @media ($tablet_portrait) {

    body {
        background: #EFEFEF;
    }

    header {
        width: 100%!important;
        overflow: hidden;
        &:before {
            content: '';
            position: absolute;
            z-index: -1;
            top: -140px;
            background: #fff;
            width: 2280px;
            height: 240px;
            left: calc(((2280px - 100vw) / 2) * -1);
             -webkit-border-radius: 150% /95%;
            -moz-border-radius:    150% / 95%; 
            border-radius:         150% / 95%;
            -webkit-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
            -moz-box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
            box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.1);
            z-index: 1000;
        }
    }
    nav {
        width: 100%;
        
        #logo_monito {
            width: 133px;
            height: 35px;
        }

        ul {
            display: none;
        }
    }
 }

 @media ($mobile) {
     header {

         &:before {
            top: -154px;
         }
        nav {
            margin-top: 18px;
            margin-bottom: 72px;
            #logo_monito a{
                width: 120px;
            }
        }
       
        &:before {
            width: 1280px;
            left: calc(((1280px - 100vw) / 2) * -1);
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Nav.vue